import { RelatedPersonCardRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestmentVehicleDetails/components/RelatedPeopleCard/relatedPeople.types.ts';
import { RelatedPersonCard } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestmentVehicleDetails/components/RelatedPeopleCard/RelatedPersonCard.tsx';
import { RelatedPeopleCardsStyles } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestmentVehicleDetails/components/RelatedPeopleCard/RelatedPeopleCards.styles.tsx';

interface Props {
	cards: RelatedPersonCardRow[];
	getInvestorPath: (investorId: string) => string;
}

export const RelatedPeopleCards = ({ cards, getInvestorPath }: Props) => (
	<RelatedPeopleCardsStyles>
		{cards.map((person) => (
			<RelatedPersonCard
				key={person.id}
				person={person}
				investorPath={person.investorId ? getInvestorPath(person.investorId) : null}
			/>
		))}
	</RelatedPeopleCardsStyles>
);
